<template>
    <AdminLayout>
        <section class="flex items-start px-14 space-x-9">
            <div class="w-full">

                <div class="pt-8">
                    <div class="flex justify-between mb-5">
                        <p class="font-semibold text-2xl text-neutral-800">Employee List</p>
                    </div>

                    <div class="flex mb-8 items-center rounded-md p-1">
                        <div class="ml-auto mr-2.5" v-if="userType === 'admin'">
                            <label class="text-sm leading-none font-normal text-black mr-2">Filter:</label>
                            <select class="border rounded-lg px-2 py-2 text-sm" v-model="slectedLocation" @change="fetchempdetails">
                                <option value="">Location</option>
                                <option v-for="branch in branchList" :key="branch.id" :value="branch.id">{{ branch.name }}</option>
                            </select>
                        </div>
                        <div v-if="userType === 'admin'">                          
                            <select class="border rounded-lg px-2 py-2 text-sm" v-model="slectedLocation" @change="fetchempdetails">
                                <option value="">Department</option>
                                <option v-for="branch in branchList" :key="branch.id" :value="branch.id">{{ branch.name }}</option>
                            </select>
                        </div>
                        <div class="w-96 mx-3">
                            <input type="search" name="" id="" class="w-full border rounded-lg bg-white text-sm px-6 py-3 outline-none block font-normal" placeholder="Search..." @input="fetchempdetails" v-model="searchData">
                        </div>
                        <div class="relative">
                            <button class="border border-[#3B82F6] text-sm px-3 py-2.5 rounded-lg text-[#3B82F6] font-medium" @click="toggleDropdown">
                                Manage Roster
                            </button>

                            <div v-if="dropdownVisible" ref="mainDropdown" class="[box-shadow:-1px_4px_16px_0px_#10182826] border border-[#3B82F6] absolute top-[35px] -right-[130px] bg-white w-[475px] p-6 rounded-lg z-10">
                                
                                <div class="relative mb-4" ref="rosterBox">
                                    <div class="text-sm px-3 py-2 rounded-md border border-neutral-300 cursor-pointer arw-rt" @click="toggleDropdown1">
                                        {{ selectedRosters.length ? selectedRosters.join(', ') : 'Select Roster(s)' }}
                                    </div>
                                    <div v-if="dropdown1Visible" class="divide-y divide-neutral-300 border border-neutral-300 rounded-md rounded-t-none absolute top-[34px] right-0 left-0 z-10 bg-white">
                                        <label v-for="(roster, index) in rosterOptions" :key="index" class="flex items-center text-xs text-neutral-700 font-normal py-2 px-3">
                                            <input type="checkbox" :value="roster.label" v-model="selectedRosters" class="mr-2"/>
                                            <span class="font-medium mr-1">{{ roster.label }}:</span>
                                            {{ roster.range }}
                                        </label>
                                    </div>
                                </div>

                                <div class="relative mb-4" ref="departmentBox">
                                    <div class="text-sm px-3 py-2 rounded-md border border-neutral-300 cursor-pointer arw-rt" @click="toggleDropdown2">
                                        {{ selectedDepartments.length ? selectedDepartments.join(', ') : 'Select Department(s)' }}
                                    </div>
                                    <div v-if="dropdown2Visible" class="divide-y divide-neutral-300 border border-neutral-300 rounded-md rounded-t-none absolute top-[34px] right-0 left-0 z-10 bg-white">
                                        <label v-for="(dept, index) in departmentOptions" :key="index" class="flex items-center text-xs text-neutral-700 font-normal py-2 px-3">
                                        <input type="checkbox" :value="dept" v-model="selectedDepartments" class="mr-2"/>
                                            {{ dept }}
                                        </label>
                                    </div>
                                </div>


                                <div class="flex items-center space-x-2 justify-end w-full">
                                    <button class="border border-red-200border border-[#3B82F6] bg-[#3B82F6] text-sm px-3 py-1 rounded text-white" @click="toggleDropdown">
                                        Apply
                                    </button>
                                    <button class="border border-red-200border border-[#3B82F6] text-sm px-3 py-1 rounded text-black" @click="toggleDropdown">
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                        <button class="border border-[#3B82F6] bg-[#3B82F6] text-sm px-3 py-2.5 rounded-lg text-white font-light ml-2.5">
                            Roster History
                        </button>
                    </div>

                    <div>
                        <div v-if="empdata">
                            <div class="glob_tablewpr rounded-lg mt-5">
                                <table class="glob_table w-full text-sm text-left text-neutral-500 ">
                                    <thead class="bg-[#ECF6FF]">
                                        <tr>
                                            <th scope="col" class="px-4 py-3 font-semibold">
                                                EMP Code
                                            </th>
                                            <th scope="col" class="px-4 py-3 font-semibold w-[240px]">
                                                Employee Name
                                            </th>
                                            <th scope="col" class="px-4 py-3 font-semibold">
                                                Email
                                            </th>
                                            <th scope="col" class="px-4 py-3 font-semibold">
                                                DEPARTMENT
                                            </th>
                                            <th scope="col" class="px-6 py-3 font-semibold">
                                                Assigned Roster
                                            </th>
                                            <th scope="col" class="px-4 py-3 font-semibold">
                                                Assign Roster
                                            </th>
                                            <th scope="col" class="px-4 py-3 font-semibold">
                                                Status
                                            </th>
                                            <th scope="col" class="px-4 py-3 font-semibold text-center" colspan="2">
                                                Action
                                            </th> 
                                        </tr>
                                    </thead>
                                    <tbody v-if="empdata.length > 0">
                                        <tr v-for="(item, index) in empdata" :key="index" class="bg-white border-b">
                                            <td scope="row" class="px-4 py-4 font-medium text-neutral-700 whitespace-nowrap">
                                                #{{ item.empid }}
                                            </td>

                                            <td class="px-4 py-4">
                                                <div class="flex items-center">
                                                    <div>
                                                        <span class="w-10 h-10 border rounded inline-block" >
                                                           
                                                            <img 
                                                                class="w-10 h-10 object-cover rounded-full" 
                                                                :src="item && item.profile_image ? `${assetUrl}media/employeeProfile/${item.profile_image}` : defaultImage" 
                                                                alt=""
                                                            />
                                                        </span>
                                                        <!-- <span class="w-10 h-10 border rounded inline-block">
                                                            KP
                                                        </span> -->
                                                    </div>
                                                    <div class="pl-3">
                                                        <p class=" text-neutral-800 font-medium">{{ item.fname }}</p>
                                                        <p class="text-xs">{{ item.jobtitle }}</p>
                                                    </div>
                                                </div>
                                            </td>

                                            <td class="px-4 py-4">
                                                {{ item.email }}
                                            </td>

                                            <td class="px-4 py-4">
                                                {{ item.dept }}
                                            </td>
                                            <td class="px-2 py-1">
                                                <table class="w-full text-sm text-left text-neutral-500 min-w-[322px]">
                                                    <thead class="text-xs text-neutral-600 uppercase bg-slate-200">
                                                        <tr>
                                                            <th class="text-[11px] leading-none p-2 font-semibold">Name</th>
                                                            <th class="text-[11px] leading-none p-2 font-semibold">Form Date</th>
                                                            <th class="text-[11px] leading-none p-2 font-semibold">To Date</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody v-if="item.rosterDetails.length > 0">
                                                    
                                                        <tr v-for="(roster, index) in item.rosterDetails" :key="index" class="bg-white border-b">
                                                            <td class="px-2 py-2 text-xs font-normal">
                                                                <p class="truncate max-w-[140px]">{{roster.rosterName}}</p>
                                                            </td>
                                                            <td class="px-2 py-2 text-xs font-normal">{{roster.effectiveFrom}}</td>
                                                            <td class="px-2 py-2 text-xs font-normal">{{roster.effectiveTo}}</td>
                                                        </tr>
                                                    
                                                    </tbody>
                                                    <tbody v-else>
                                                        <tr class="bg-white border-b">
                                                            <td class="px-2 py-2 text-xs font-normal" colspan="3">Roster Not Assigned</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                            <td class="px-4 py-4">
                                                <div class="flex">
                                                    <select 
                                                        v-model="item.selectedRosterId" 
                                                        @change="saveRoster(item)"
                                                    >
                                                        <option value="" disabled>-Select Roster-</option>
                                                        <option v-for="roster in rosterdata" :key="roster.id" :value="roster.id">{{ roster.rosterName }}</option>
                                                    </select>
                                                </div>
                                            </td>

                                            <td class="px-4 py-4">
                                                <Switch
                                                    v-model="item.active_status" @click="activestatus(item.active_status, item.id)"
                                                    :class="item.active_status ? 'bg-blue-500 border-blue-500' : 'bg-gray-200 border-gray-200'"
                                                    class="relative inline-flex h-[20px] w-[38px] shrink-0 cursor-pointer rounded-full border transition-colors duration-300 ease-in-out focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75"
                                                    >
                                                    <span class="sr-only">Use setting</span>
                                                    <span
                                                        aria-hidden="true"
                                                        :class="item.active_status ? 'translate-x-[18px]' : 'translate-x-0'"
                                                        class="pointer-events-none inline-block h-[18px] w-[18px] transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out"
                                                    />
                                                </Switch>
                                            </td>

                                            <td class="px-4 py-4 text-right">
                                            <div class="flex space-x-2">
                                                    <router-link :to="`/view-employee-details/${item.uid}`" class="edtl inline-block ml-auto">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><g fill="none" stroke="currentColor" stroke-width="1.5"><path d="M3.275 15.296C2.425 14.192 2 13.639 2 12c0-1.64.425-2.191 1.275-3.296C4.972 6.5 7.818 4 12 4s7.028 2.5 8.725 4.704C21.575 9.81 22 10.361 22 12c0 1.64-.425 2.191-1.275 3.296C19.028 17.5 16.182 20 12 20s-7.028-2.5-8.725-4.704Z"/><path d="M15 12a3 3 0 1 1-6 0a3 3 0 0 1 6 0Z"/></g></svg>
                                                    </router-link>
                                                    
                                                    <router-link :to="`/edit-employee-details/${item.uid}`" class="edtl inline-block ml-auto">
                                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-5 h-5">
                                                            <path stroke-linecap="round" stroke-linejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
                                                        </svg>
                                                    </router-link>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tbody v-else>
                                        <tr class="bg-white border-b">
                                            <td class="px-4 py-4 text-xs font-normal" colspan="8">No Data Found</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="flex justify-end pt-3">
                                <MultiPageComponent :page="pageData?.page" :totalPages="pageData?.totalPages"
                                @page-change="handlePageChange" />
                            </div>
                        </div>
                        <div v-else class="overflow-x-auto sm:rounded-lg pt-5">
                            <table class="w-full text-sm text-left text-neutral-500 ">
                                <thead class="text-xs text-neutral-400 uppercase bg-neutral-200 animate-pulse">
                                    <tr>
                                        <th scope="col" class="px-6 py-3 font-semibold">
                                            <span class="w-28 rounded h-5 bg-neutral-300 inline-block"></span>
                                        </th>
                                        <th scope="col" class="px-6 py-3 font-semibold">
                                            <span class="w-28 rounded h-5 bg-neutral-300 inline-block"></span>
                                        </th>
                                        <th scope="col" class="px-6 py-3 font-semibold">
                                            <span class="w-28 rounded h-5 bg-neutral-300 inline-block"></span>
                                        </th>
                                        <th scope="col" class="px-6 py-3 font-semibold">
                                            <span class="w-28 rounded h-5 bg-neutral-300 inline-block"></span>
                                        </th>
                                        <th scope="col" class="px-6 py-3 font-semibold">
                                            <span class="w-28 rounded h-5 bg-neutral-300 inline-block"></span>
                                        </th>
                                        <th scope="col" class="px-6 py-3 font-semibold text-right">
                                            <span class="w-28 rounded h-5 bg-neutral-300 inline-block"></span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody class="animate-pulse">
                                    <tr v-for=" index in 8" :key="index" class="bg-white border-b">
                                        <td scope="row" class="px-6 py-4 font-medium text-neutral-700 whitespace-nowrap">
                                            <span class="w-28 rounded h-5 bg-neutral-200 inline-block"></span>
                                        </td>

                                        <td class="px-6 py-4">
                                            <span class="w-28 rounded h-5 bg-neutral-200 inline-block"></span>
                                        </td>

                                        <td class="px-6 py-4">
                                            <span class="w-28 rounded h-5 bg-neutral-200 inline-block"></span>
                                        </td>

                                        <td class="px-6 py-4">
                                            <span class="w-28 rounded h-5 bg-neutral-200 inline-block"></span>
                                        </td>

                                        <td class="px-6 py-4">
                                            <span class="w-28 rounded h-5 bg-neutral-200 inline-block"></span>
                                        </td>

                                        <td class="px-6 py-4 text-right">
                                            <span class="w-28 rounded h-5 bg-neutral-200 inline-block"></span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div> 
                        
                    </div>        
                </div>   
            </div>
            
            <!-- <RightSideBar/> -->
        </section>
    </AdminLayout>

</template>


<script>
    import AdminLayout from './AdminLayout.vue';   
    import { Switch } from '@headlessui/vue';
    import { BASE_URL } from "../../config";
    import axios from "axios";
    import { createLocal } from 'the-storages';
    import { createToast } from 'mosha-vue-toastify';
    import { reactive } from "vue";
    // import RightSideBar from '../../components/RightSideBar.vue';
    import MultiPageComponent from "../../components/Widgets/MultiPageComponent.vue";
    import defaultImage from '../../assets/user.png'; 
    const mirror = createLocal();
    const storage = mirror._prx;
    import { BASE_URL_POP } from "../../config";

    export default {
        name: 'EmployeeList',
        components:{
            AdminLayout, 
            // RightSideBar,
            Switch,
            MultiPageComponent,
        },
        setup() {
            const addfield = reactive({
                field_name: '',
                field_type: '',
                field_status: '',
            })

            return {
                addfield,
                // roster
            }
        },

        data() {
            return {               
                currentPage: 1,
                searchData: "",
                pageData: {},
                // isLoader: true,
                defaultImage: defaultImage,
                storage:storage,              
                editrow: false,
                itemtobeedited:{},
                fieldtobedeleted:'',
                res_message:'',
                selectedOptions: [],
                availableOptions: [],

                empdata:'',
                infoarray:[],
                toggledata:'',
                rosterdata:[],
                branchList: [],  
                slectedLocation: '',   
                userType: '',     
                assetUrl: BASE_URL_POP,   
                dropdownVisible: false, 
                dropdown1Visible: false,
                dropdown2Visible: false,
                selectedRosters: [],
                selectedDepartments: [],
                rosterOptions: [
                    { label: 'Roster 1', range: 'Effective From 06/2025 - Effective To 08/2025' },
                    { label: 'Roster 2', range: 'Effective From 07/2025 - Effective To 08/2025' },
                    { label: 'Roster 5', range: 'Effective From 08/2025 - Effective To 10/2025' },
                ],
                departmentOptions: [
                    'Sales & Marketing',
                    'Product Management',
                    'Frontend Developer',
                    'UI/UX Designer',
                ],
            }
        },
       
        created(){
            // console.log('emp-storage', this.storage);
            if (this.storage.userType === 'Super Admin') {               
                this.slectedLocation = ''; // Set to an empty string or a default value
                this.userType = 'admin';
            } else {
                this.slectedLocation = this.storage.employeeDetails.branch; // Assign only if branch is valid
                this.userType = 'not-admin';
                console.log('branch', this.slectedLocation);
            }
         
            this.currentPage = this.$route.query.page ? this.$route.query.page : 1;
            this.fetchempdetails();
            this.fetchrosterdetails();
            this.getBranchList();
           
        },
        mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  },
        methods:{
            async fetchempdetails(){
                await axios.post(BASE_URL + '/fetchaddedemployeedetails',{
                    'company_id':this.storage.company_id,
                    'page':this.currentPage,
                    'limit':5,
                    'search':this.searchData,
                    'location':this.slectedLocation,
                })
                .then((response)=>{
                    console.log('emp-info',response.data);
                    this.empdata = response.data.userdetails.map(user => ({
                        ...user,
                        roster: { 
                            allocated_roster: user.roster_allocated, allocated_roster_name: user.roster_name 
                        }, 
                        selectedRosterId: user.rosterDetails.length > 0 
                        ? user.rosterDetails[user.rosterDetails.length - 1].roster_id 
                        : '', 
                        // Default to allocated_roster if no rosterDetails
                        // roster: { allocated_roster: user.roster ? user.roster.roster_name || '' : '' }, 
                    }));
                    this.pageData = response.data.pagination;
                })

                console.log("empdata",this.empdata);
            },

            async fetchrosterdetails(){

                await axios.post(BASE_URL + '/fetchRosterDetails',{
                        'company_id':this.storage.company_id,
                    })
                .then((response)=>{
                    console.log("rosterdata", response.data.rosterDetails);
                    this.rosterdata = response.data.rosterDetails

                })
            },
             
            async getBranchList() {
                const formData = {
                    "company_id":this.storage.companyDetails.id
                };
                await axios.post(BASE_URL + '/get-emp-branch-list',formData)
                .then((response)=>{
                    this.branchList =  response.data.branchDetails;
                    console.log("Role LIST:: ",response.data);
                })
            },
            async saveRoster(user) {
                console.log("user", user);
                // Make an API call to save the selected roster for the user
                await axios.post(BASE_URL + '/assignRoster', {
                    userId: user.uid, // Replace with the actual user identifier
                    rosterId: user.selectedRosterId,
                    company_id: this.storage.company_id,
                }).then((response)=>{
                    if(response.data.success === 'success'){
                        this.tostMessage('success', response.data.message);
                    }else{
                        this.tostMessage('danger', response.data.message);
                    }
                    this.fetchempdetails();
                })
            },
            
            async activestatus(status, id){
                console.log(status, id);
                if (status == true) {
                    status = false;
                } else {
                    status = true;
                    
                }
                var dataval = {
                                'status':status,
                                'company_id':this.storage.company_id,
                                'emp_id':id
                            }

                await axios.post(BASE_URL + '/updatempstatus',dataval)
                    .then((response)=>{
                        // console.log(response.data);
                        this.tostMessage(response.data.success, response.data.message);
                        this.empdata = response.data.empdata
                    })

                    this.fetchempdetails();

                    // this.fetchempdetails();


            },
          
            tostMessage(status,message){
                createToast({
                    // title: title,
                    description: message
                },
                {
                type: status,
                timeout: 2500,
                position: 'bottom-right',
                showIcon: 'true'
                })
            },
            
            handlePageChange(newPage) {
                if (this.$route.query.page === newPage) return
                    const query = { ...this.$route.query }
                    if (newPage) query.page = newPage
                    else delete query.page
                    this.$router.replace({ query })
                    this.currentPage = newPage;
                    this.fetchempdetails(this.searchData);
            },
            toggleDropdown() {
                this.dropdownVisible = !this.dropdownVisible;
            },
            toggleDropdown1() {
            this.dropdown1Visible = !this.dropdown1Visible;
            this.dropdown2Visible = false;
            },
            toggleDropdown2() {
            this.dropdown2Visible = !this.dropdown2Visible;
            this.dropdown1Visible = false;
            },
            applySelections() {
            console.log('Selected Rosters:', this.selectedRosters);
            console.log('Selected Departments:', this.selectedDepartments);
            this.dropdownVisible = false;
            },
            handleClickOutside(event) {
            const rosterEl = this.$refs.rosterBox;
            const deptEl = this.$refs.departmentBox;

            if (this.dropdown1Visible && rosterEl && !rosterEl.contains(event.target)) {
                this.dropdown1Visible = false;
            }

            if (this.dropdown2Visible && deptEl && !deptEl.contains(event.target)) {
                this.dropdown2Visible = false;
            }
            },
        }
        

    }


</script>
